export function detailRechartsTheme(isDark: boolean) {
  return {
    gridStroke: isDark ? '#475569' : '#cbd5e1',
    tick: isDark ? '#94a3b8' : '#475569',
    tooltipBg: isDark ? '#1e293b' : '#fff',
    tooltipBorder: isDark ? '#334155' : '#e5e7eb',
  }
}
